(function () {
	'use strict';

	angular
		.module('portalApp')
		.service('subjectManagerService', SubjectManagerService);

	/*
	 * @ngInject
	 */
	function SubjectManagerService($log, $http, appSession, appConfig, loadingIndicatorService, popupService, appI18n) {

		return {
			getCreateSubjectData,
			createSubject,
			editSubject,
			getEditSubjectData,
			getEditDeviceValueData,
			getSubjects,
			getSubjectMinimal,
			getSitesMinimal,
			updateSubject,
			getActions,
			getStudyActivities,
			getScheduledEvents
		};

		function getStudyActivities() {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.iSpiro.studyActivities
				  .supplant({
					  'studyId': currentStudy.id,
					  'studyModeId': currentStudy.studyModeId,
				  });

			return $http.get(url, { cache: true, params: { cacheContext: 'clinicalData' } });
		}

		function getActions(countryId, siteId, subjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.iSpiro.actions
				  .supplant({
					  'studyId': currentStudy.id,
					  'studyModeId': currentStudy.studyModeId,
					  countryId,
					  siteId,
					  subjectId
				  });

			return $http.get(url);
		}


		function getSubjects(countryId, siteId, actionId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.iSpiro.subjects
				  .supplant({
					  'studyId': currentStudy.id,
					  'studyModeId': currentStudy.studyModeId,
					  countryId: countryId || '',
					  siteId: siteId || '',
					  actionId
				  });

			return $http.get(url);
		}

		function getSubjectMinimal(siteId, technicalSubjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.iSpiro.subject
				  .supplant({
					  'studyId': currentStudy.id,
					  'studyModeId': currentStudy.studyModeId,
					  siteId,
					  technicalSubjectId
				  });

			return $http.get(url);
		}

		function getSitesMinimal(studyObj, countryId) {
			let currentStudy = {};

			if (studyObj && studyObj.id && studyObj.studyModeId !== null) {
				currentStudy = studyObj;
			} else {
				currentStudy = appSession.getStudy();
			}
			const url = appConfig.apiUrls.clinicalData.iSpiro.sitesMinimal.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				'countryId': countryId || ''
			});

			$log.debug('clinicalDataService.getSites with url: {url}', {
				url
			});
			return $http.get(url, {
				cache: true,
				params: {
					cacheContext: 'clinicalData'
				}
			});
		}

		function getScheduledEvents(siteId, subjectKey, from, to) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.iSpiro.scheduledEvents
				  .supplant({
					  'studyId': currentStudy.id,
					  'studyModeId': currentStudy.studyModeId,
					  siteId,
					  subjectKeyFilter: subjectKey || '',
					  from,
					  to
				  });

			return $http.get(url);
		}
	

		function getCreateSubjectData(countryId, siteId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.subjectManager.createSubject.data.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				'countryId': countryId || '0',
				'siteId': siteId || '0'
			});

			return $http.get(url);
		}

		function createSubject(subject) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.subjectManager.createSubject.create.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId
			});

			return $http.post(url, subject);
		}

		function editSubject(payload, subjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.iSpiro.editSubject.update.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				subjectId
			});

			return $http.put(url, payload);
		}

		function updateSubject(payload, subjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.subjectManager.editSubject.update.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				subjectId,
				'forDispense': 'false',
				'isRemoteAction': 'false'
			});

			return $http.put(url, payload);
		}

		function getEditSubjectData(countryId, siteId, subjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.subjectManager.editSubject.data.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				'countryId': countryId || '0',
				'siteId': siteId || '0',
				subjectId
			});

			return $http.get(url);
		}

		function getEditDeviceValueData(countryId, siteId, subjectId) {
			const currentStudy = appSession.getStudy();
			const url = appConfig.apiUrls.clinicalData.subjectManager.editSubject.editDeviceValues.supplant({
				'studyId': currentStudy.id,
				'studyModeId': currentStudy.studyModeId,
				'countryId': countryId || '0',
				'siteId': siteId || '0',
				subjectId
			});

			return $http.get(url);
		}
	}
})();
